import { create } from 'zustand';
import { persist } from 'zustand/middleware';
import { logAction } from '../utils/auditLogger';

export type UserRole = 'admin' | 'user' | null;

export interface UserProfile {
  id: string;
  role: UserRole;
}

interface AuthState {
  user: UserProfile | null;
  isAuthenticated: boolean;
  
  login: (pin: string) => boolean;
  logout: () => void;
}

const ADMIN_PIN = '123456';
const USER_PIN = '654321';

export const useAuthStore = create<AuthState>()(
  persist(
    (set) => ({
      user: null,
      isAuthenticated: false,

      login: (pin: string) => {
        let newRole: UserRole = null;
        if (pin === ADMIN_PIN) newRole = 'admin';
        if (pin === USER_PIN) newRole = 'user';
        
        if (newRole) {
          const user = { id: crypto.randomUUID(), role: newRole };
          set({ user, isAuthenticated: true });
          
          // Log login asynchronously
          setTimeout(() => {
            logAction(newRole, 'LOGIN', { method: 'PIN' });
          }, 0);
          
          return true;
        }
        return false;
      },
      logout: () => {
        set((state) => {
          if (state.user?.role) {
            logAction(state.user.role, 'LOGOUT', {});
          }
          return { user: null, isAuthenticated: false };
        });
      },
    }),
    {
      name: 'pdf-auth-storage',
    }
  )
);
